var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreyPin = function SvgGreyPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00024 14C4.25609 12.5158 2.9535 11.1372 2.09248 9.86408C1.23102 8.5914 0.800293 7.41339 0.800293 6.33007C0.800293 4.70509 1.3231 3.41051 2.36873 2.44636C3.41392 1.4822 4.62442 1.00012 6.00024 1.00012C7.37606 1.00012 8.58678 1.4822 9.6324 2.44636C10.6776 3.41051 11.2002 4.70509 11.2002 6.33007C11.2002 7.41339 10.7695 8.5914 9.908 9.86408C9.04698 11.1372 7.74439 12.5158 6.00024 14Z",
    stroke: "#707577",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00021 7.50006C6.89766 7.50006 7.62519 6.77254 7.62519 5.87509C7.62519 4.97765 6.89766 4.25012 6.00021 4.25012C5.10277 4.25012 4.37524 4.97765 4.37524 5.87509C4.37524 6.77254 5.10277 7.50006 6.00021 7.50006Z",
    stroke: "#707577",
    strokeWidth: 1.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreyPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "grey-pin.5b0c2a2d398424c699649a8c651eb32a.svg";